import React, { useEffect, useState } from 'react'
import { Container, Row, Col, Card, Form, Button } from "react-bootstrap";
import { FaCamera } from "react-icons/fa";

import "./CustomForm.css"
import TimePicker from 'react-time-picker';
function CustomForm({ formStructure, image, onSubmit, initialData }) {
  const [formValues, setFormValues] = useState({});
  const [imagePreview, setImagePreview] = useState(null);
  const [isImageDeleted, setIsImageDeleted] = useState(false);
  const handleChange = (key, value, isFile = false) => {
    if (isFile) {
      setIsImageDeleted(false);
      setFormValues((prev) => ({
        ...prev,
        [key]: value, // file object
      }));

      // preview
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result);
      };
      reader.readAsDataURL(value);
    } else {
      setFormValues((prev) => ({
        ...prev,
        [key]: value,
      }));
    }
  };
  useEffect(() => {
    if (initialData && Object.keys(initialData).length > 0) {
      setFormValues(initialData);

      // 🔥 هنا الحل
      if (initialData.image) {
        setImagePreview(initialData.image);
      }
    }
  }, [initialData]);
  //     const handleChange = (key, value) => {
  //   setFormValues((prev) => ({
  //     ...prev,
  //     [key]: value, // This updates the specific field
  //   }));
  // };

  // Make sure initialData is actually an object before setting it
  useEffect(() => {
    if (initialData && Object.keys(initialData).length > 0) {
      setFormValues(initialData);
    }
  }, [initialData]);
  // useEffect(() => {
  //     if (initialData) {
  //       setFormValues(initialData);
  //     }
  //   }, [initialData]);

  // const handleChange = (key, value) => {
  //     setFormValues((prev) => ({ ...prev, [key]: value }));
  //   };

  const renderInput = (input) => {
    console.log(input?.value);

    const val = input?.value ? input?.value : formValues[input.id] || "";
    switch (input.type) {

      case "text":
        return (
          <Form.Control
            placeholder={input.title}
            onChange={(e) => handleChange(input.id, e.target.value)}
            value={val}
            disabled={input?.disable}
          />
        );

      case "textarea":
        return (
          <Form.Control
            as="textarea"
            rows={3}
            placeholder={input.title}
            value={val}

            onChange={(e) => handleChange(input.id, e.target.value)}
          />
        );



      case "file":
        return (
          <>
            <Form.Control
              type="file"
              accept="image/*"
              onChange={(e) =>
                handleChange(input.id, e.target.files[0], true)
              }
            />
            {imagePreview && (
              <div style={{ position: "relative" }}>
                <img
                  src={imagePreview}
                  alt="preview"
                  style={{
                    width: "200px",
                    height: "150px",
                    objectFit: "contain",
                    marginTop: "10px",
                  }}
                />

                <Button
                  variant="danger"
                  size="sm"
                  style={{
                    position: "absolute",
                    top: "5px",
                    right: "5px",
                  }}
                  onClick={() => {
                    setImagePreview(null);
                    setIsImageDeleted(true);

                    setFormValues((prev) => ({
                      ...prev,
                      image: null,
                    }));
                  }}
                >
                  حذف
                </Button>
              </div>
            )}
            {/* {imagePreview && (
        <img
          src={imagePreview}
          alt="preview"
          style={{
            width: "200px",
            height: "150px",
objectFit:"contain",
            marginTop: "10px",

          }}
        />
      )} */}
          </>
        );
      case "select":
        return (
          <Form.Select
            onChange={(e) => handleChange(input.id, e.target.value)}
            value={val}


          >
            <option>اختر</option>
            {input?.options?.map((opt, i) => {
              console.log(opt);

              return (
                <option key={i} value={opt?.id}>{opt?.name}</option>
              )
            })}
          </Form.Select>
        );
    case "time":
        return (
          <input
 onChange={(e) => handleChange(input.id, e.target.value)}
  value={val}
          type='time'
          className='form-control'
          />
          // <TimePicker
          //   value={val}

          //   onChange={(e) => handleChange(input.id, e.target.value)}
          //  />

        );



            case "date":
        return (
          <input
 onChange={(e) => handleChange(input.id, e.target.value)}
  value={val}
          type='date'
          className='form-control'
          />
          // <TimePicker
          //   value={val}

          //   onChange={(e) => handleChange(input.id, e.target.value)}
          //  />

        );

      default:
        return null;
    }
  };


  return (
    <Row className="g-4">

      {/* Basic Info */}
      {formStructure?.map((section) => {
        return (
          <Col md={8} xs={12} key={section?.id}>
            <Card className="p-4 mb-4 shadow-sm border-0 rounded-4">
              <h6 className="fw-bold mb-3">{section.title}</h6>

              <Row className="g-3">
                {section.inputs.map((input) => (
                  <Col md={6} xs={12} key={input.id}>
                    <Form.Group>
                      <Form.Label className="small text-muted">
                        {input.title}
                      </Form.Label>

                      {renderInput(input)}
                    </Form.Group>
                  </Col>
                ))}
              </Row>
            </Card>
          </Col>
        )
      })}

      {/* Visuals */}
      {image ?
        <Col md={4} xs={12}>
          <Card className="p-4 shadow-sm border-0 rounded-4 text-center">
            <h6 className="fw-bold mb-3">الصور</h6>

            <div className="upload-box d-flex flex-column justify-content-center align-items-center">

              <div className="icon-circle mb-2">
                <FaCamera />
              </div>

              <p className="mb-1 fw-semibold text-nowrap">
                قم بتحميل صور عالية الجودة
              </p>

              <small className="text-muted">
                الحجم الموصى به: 1080×1080 بكسل (PNG، JPG)
              </small>
            </div>
          </Card>
        </Col>
        :
        <Col md={4}></Col>
      }

      <div className="text-end w-50 btn_container">
        <Button
          onClick={() => onSubmit(formValues)}
          className='w-100'
        >
          حفظ
        </Button>
      </div>

    </Row>
  )
}

export default CustomForm